import { signal } from '@angular/core';

// Shared by Angular HttpClient and the existing fetch transport.
export const maintenanceActive = signal(false);
let generation = 0;
let returnPath: string | undefined;
export const maintenanceReturnPath = () => returnPath;
export const maintenanceGeneration = () => generation;
export function enterMaintenance(): void {
  if (!maintenanceActive() && typeof window !== 'undefined') {
    returnPath = window.location.pathname + window.location.search + window.location.hash;
  }
  generation++;
  maintenanceActive.set(true);
}
export function maintenanceError(): Error & { status: number; code: string } {
  return Object.assign(new Error('Estamos actualizando League of Managers. Volveremos en unos minutos.'),
    { status: 503, code: 'MAINTENANCE_MODE' });
}
export function assertMaintenanceAvailable(): void {
  if (maintenanceActive()) throw maintenanceError();
}
export function recognizeMaintenance(status: number, body: unknown): boolean {
  if (status !== 503 || !body || (body as { code?: string }).code !== 'MAINTENANCE_MODE') return false;
  enterMaintenance();
  return true;
}
export async function inspectMaintenanceResponse(response: Response): Promise<void> {
  if (response.status !== 503) return;
  const body = await response.clone().json().catch(() => null);
  if (recognizeMaintenance(response.status, body)) throw maintenanceError();
}
